/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';

// #endregion Local Imports

const pathname = '/galleries';

export const GalleryApi = {
  find: async (option: FilterGalleryOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    const url = pathname;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterGalleryOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  status?: number;
}
